import { ClientTypeSelect } from 'components/Sales/Quotes/AddQuote/QuoteForm'
import { strVal } from 'modules/Utils'
import React, { useEffect, useState } from 'react'
import { Checkbox, Col, Form, Icon, Input, Row } from 'antd'
import { get } from 'lodash'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'
import CentersCascader from '../../../../../elements/Cascader/CentersCascader'

const { TextArea } = Input

function Overview(props) {
  const formItemLayoutRow = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  }
  const { getFieldDecorator, getFieldValue } = props.form
  const { contract, CustomerOrderSelect } = props

  const type = getFieldValue('type')

  const isBlanket = getFieldValue('blanket')

  const [emailsLen, setEmailsLen] = useState(get(contract, 'mailOrder', []).length)

  useEffect(() => {
    if (get(contract, 'mailOrder')) setEmailsLen(get(contract, 'mailOrder', []).length)
  }, [contract])

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <Form.Item label="Title" {...formItemLayoutRow}>
            {getFieldDecorator('title', {
              initialValue: strVal(contract, 'title'),
              rules: [{ required: true, message: "Title can't be empty " }],
            })(<Input placeholder="Title" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Blanket" {...formItemLayoutRow}>
            {getFieldDecorator('blanket', {
              initialValue: !!contract.blanket,
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Main Contract (Partner Site)" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
            {getFieldDecorator('isMainContract', {
              initialValue: !!contract.isMainContract,
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Share Contract (Partner Site)" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
            {getFieldDecorator('isToPartner', {
              initialValue: !!contract.isToPartner,
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Company" {...formItemLayoutRow}>
            {getFieldDecorator('company._id', {
              initialValue: get(contract, 'company._id'),
              rules: [{ required: true, message: "Company can't be empty" }],
            })(
              <OrganisationsSelect
                onChange={() => props.form.resetFields(['budget.cost._id'])}
                placeholder={'Select a Company'}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Profit Center" {...formItemLayoutRow}>
            {getFieldDecorator('budget.cost._id', {
              initialValue: get(contract, 'budget.cost._id'),
              rules: [
                {
                  type: 'array',
                  required: true,
                  message: "Profit Center can't be empty ",
                },
              ],
            })(
              <CentersCascader
                key={props.form.getFieldValue('company._id')}
                category={'Profit'}
                company={props.form.getFieldValue('company._id')}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Business Registration" {...formItemLayoutRow}>
            {getFieldDecorator('client.companyno', {
              initialValue: strVal(contract, 'client.companyno'),
            })(<Input placeholder="Business Registration No" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Tax Registration" {...formItemLayoutRow}>
            {getFieldDecorator('client.taxRegistration', {
              initialValue: strVal(contract, 'client.taxRegistration'),
            })(<Input placeholder="Tax Registration No" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Type" {...formItemLayoutRow}>
            {getFieldDecorator('type', {
              initialValue: get(contract, 'type'),
              rules: [
                {
                  required: true,
                  message: "Type can't be empty ",
                },
              ],
            })(<ClientTypeSelect />)}
          </Form.Item>
        </Col>
        {isBlanket && (
          <Col span={12}>
            <Form.Item label="CPO" {...formItemLayoutRow}>
              {getFieldDecorator('cpo._id', {
                initialValue: get(contract, 'cpo._id'),
              })(<CustomerOrderSelect keyAtr={'_id'} valueAtr={'no'} placeholder={'CPO'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Description" {...formItemLayoutRow}>
            {getFieldDecorator('description', {
              initialValue: get(contract, 'description'),
            })(<TextArea placeholder="Description" rows={4} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {[...Array(emailsLen).keys()].map((index) => (
          <Col span={12}>
            <Form.Item label={`Email Order ${index + 1}`} {...formItemLayoutRow}>
              {getFieldDecorator(`mailOrder[${index}]`, {
                initialValue: get(contract, `mailOrder[${index}]`),
              })(
                <Input placeholder="Email Order Address" style={{ width: emailsLen - 1 === index ? '80%' : '100%' }} />
              )}
              {emailsLen - 1 === index && <Icon onClick={() => setEmailsLen((e) => e + 1)} type="plus-circle" />}
              {emailsLen - 1 === index && <Icon onClick={() => setEmailsLen((e) => e - 1)} type="minus-circle" />}
            </Form.Item>
          </Col>
        ))}
        {type === 'Online Sales' && (
          <>
            <Col span={12}>
              <Form.Item label="Realm" {...formItemLayoutRow}>
                {getFieldDecorator('realm', {
                  initialValue: strVal(contract, 'realm'),
                  rules: [
                    {
                      required: true,
                      message: "Realm can't be empty ",
                    },
                  ],
                })(<Input placeholder="Realm" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="apiKey" {...formItemLayoutRow}>
                {getFieldDecorator('apiKey', {
                  initialValue: strVal(contract, 'apiKey'),
                })(<Input placeholder="apiKey" />)}
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Form>
  )
}

const WrappedOverviewForm = Form.create()(Overview)

export default WrappedOverviewForm
